var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box profile-card-2" }, [
    _vm._m(0),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c(
          "div",
          { staticClass: "row investor_list" },
          _vm._l(_vm.form.looking_for, function (data, i) {
            return _c("div", { key: i, staticClass: "investor_data" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.handleSelectName(data)) +
                  "\n        "
              ),
            ])
          }),
          0
        ),
      ]),
    ]),
    _c(
      "div",
      {
        staticClass: "modal",
        attrs: {
          id: "editLookingFor",
          tabindex: "-1",
          "aria-labelledby": "editLookingForLabel",
          "aria-hidden": "true",
        },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog", staticStyle: { width: "550px" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(1),
              _c("form", { on: { submit: _vm.updateLookingFor } }, [
                _c(
                  "div",
                  {
                    staticClass: "modal-body",
                    staticStyle: { padding: "30px", "padding-top": "50px" },
                  },
                  [
                    _vm.fetchLookingForError != ""
                      ? _c(
                          "div",
                          [
                            _c("center", [
                              _c("br"),
                              _c("img", {
                                staticStyle: {
                                  "margin-top": "30px",
                                  width: "150px",
                                },
                                attrs: { src: "/img/cancel.png" },
                              }),
                              _c("br"),
                              _c("br"),
                              _c(
                                "p",
                                { staticStyle: { "margin-top": "30px" } },
                                [
                                  _vm._v(
                                    "\n                  Error detected while loading Roles\n                "
                                  ),
                                ]
                              ),
                              _c("code", [
                                _vm._v(_vm._s(this.fetchLookingForError)),
                              ]),
                              _c("br"),
                              _c("br"),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("div", { staticClass: "form-grouped" }, [
                      _vm.isLoadingLookingFor == true
                        ? _c("div", { staticClass: "list-wrapper" }, [
                            _c("img", {
                              staticClass: "button-spinner",
                              staticStyle: { "margin-left": "10px" },
                              attrs: { src: "/img/lightbox/preloader.gif" },
                            }),
                          ])
                        : _vm._e(),
                      _vm.isLoadingLookingFor == false
                        ? _c(
                            "div",
                            { staticClass: "chip-btn-container" },
                            _vm._l(
                              _vm.teamRolesArrData,
                              function (item, index) {
                                return _c("ChipButton", {
                                  key: index,
                                  attrs: {
                                    text: item.name,
                                    dashedBorder: true,
                                    buttonIcon:
                                      "img/onboarding/specify_preferences/" +
                                      item.img,
                                    selected: _vm.checkedSelectedTeamRole(
                                      item.id
                                    ),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleSelectTeamRole(item.id)
                                    },
                                  },
                                })
                              }
                            ),
                            1
                          )
                        : _vm._e(),
                    ]),
                  ]
                ),
                _c("div", { staticClass: "modal-footer" }, [
                  _vm.isUpdatedLookingFor
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            right: "0",
                            "margin-top": "0%",
                            "text-align": "center",
                          },
                          attrs: { id: "loaderCal" },
                        },
                        [
                          _c("v-progress-circular", {
                            attrs: {
                              size: 30,
                              color: "primary",
                              indeterminate: "",
                            },
                          }),
                          _vm._v(
                            "\n              " +
                              _vm._s("updating looking for/roles...") +
                              "\n            "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.isUpdatedLookingFor
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-light lightBorder p-3",
                          attrs: { type: "button", "data-bs-dismiss": "modal" },
                        },
                        [_vm._v("\n              Cancel\n            ")]
                      )
                    : _vm._e(),
                  !_vm.isUpdatedLookingFor && _vm.fetchLookingForError == ""
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-primary p-3",
                          attrs: { type: "submit" },
                        },
                        [_vm._v("\n              Update\n            ")]
                      )
                    : _vm._e(),
                ]),
              ]),
            ]),
          ]
        ),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "modal",
        attrs: {
          id: "errorModalLookingFor",
          tabindex: "-1",
          "aria-labelledby": "errorModalLookingForLabel",
          "aria-hidden": "true",
        },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog", staticStyle: { width: "450px" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(2),
              _c(
                "div",
                {
                  staticClass: "modal-body",
                  staticStyle: { "text-align": "center" },
                },
                [
                  _c("br"),
                  _c("img", {
                    staticStyle: { "margin-top": "30px", width: "150px" },
                    attrs: { src: "/img/cancel.png" },
                  }),
                  _c("br"),
                  _c("br"),
                  _c("p", { staticStyle: { "margin-top": "30px" } }, [
                    _vm._v("Error detected while updating Roles"),
                  ]),
                  _c("code", [_vm._v(_vm._s(this.LookingForUpdateError))]),
                  _c("br"),
                  _c("br"),
                ]
              ),
              _vm._m(3),
            ]),
          ]
        ),
      ]
    ),
    _vm._m(4),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-6", staticStyle: { "text-align": "left" } },
        [_c("span", { staticClass: "start_up_label" }, [_vm._v("Looking for")])]
      ),
      _c(
        "div",
        {
          staticClass: "col-6",
          staticStyle: { "text-align": "right" },
          attrs: {
            "data-bs-toggle": "modal",
            "data-bs-target": "#editLookingFor",
          },
        },
        [_c("span", { staticClass: "start_up_edit" }, [_vm._v("Edit")])]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }, [
        _vm._v("Edit Looking For/Roles"),
      ]),
      _c("button", {
        staticClass: "btn-close",
        attrs: {
          type: "button",
          "data-bs-dismiss": "modal",
          "aria-label": "Close",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }, [_vm._v("ERROR DETECTED")]),
      _c("button", {
        staticClass: "btn-close",
        attrs: {
          type: "button",
          "data-bs-dismiss": "modal",
          "aria-label": "Close",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-light lightBorder",
          attrs: { type: "button", "data-bs-dismiss": "modal" },
        },
        [_vm._v("\n            Close\n          ")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "modal",
        attrs: {
          id: "successChangeRequestModalLookingFor",
          tabindex: "-1",
          "aria-labelledby": "successChangeRequestModalLabel",
          "aria-hidden": "true",
        },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog", staticStyle: { width: "450px" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("h5", { staticClass: "modal-title" }, [
                  _vm._v("Looking For/Roles Updated"),
                ]),
                _c("button", {
                  staticClass: "btn-close",
                  attrs: {
                    type: "button",
                    "data-bs-dismiss": "modal",
                    "aria-label": "Close",
                  },
                }),
              ]),
              _c(
                "div",
                {
                  staticClass: "modal-body",
                  staticStyle: { "text-align": "center" },
                },
                [
                  _c("br"),
                  _c("img", {
                    staticStyle: { "margin-top": "30px", width: "150px" },
                    attrs: { src: "/img/marked.svg" },
                  }),
                  _c("br"),
                  _c("br"),
                  _c("p", { staticStyle: { "margin-top": "30px" } }, [
                    _vm._v(
                      "\n            Looking For/Roles record updated successfully\n          "
                    ),
                  ]),
                  _c("br"),
                  _c("br"),
                ]
              ),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-light lightBorder",
                    attrs: { type: "button", "data-bs-dismiss": "modal" },
                  },
                  [_vm._v("\n            Close\n          ")]
                ),
              ]),
            ]),
          ]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }